import { useEffect } from 'react';
import { ArrowRight } from 'lucide-react';
import { accessEmailHref, requestAccessHref } from '@/lib/access-request';
import { BrandAtmosphere } from '@/components/BrandAtmosphere';
import { WebsiteFooter } from '@/components/WebsiteFooter';
import '../sign-up.css';
import '../signup-foundation.css';

// Owner-supplied presentation milestones, not automatic delivery telemetry.
const milestones = [
  { title: 'Concept and design', status: 'Complete', state: 'complete' },
  { title: 'Platform build', status: 'In progress', state: 'current' },
  { title: 'Private pilot', status: 'Next', state: 'upcoming' },
  { title: 'Public launch', status: 'Soon', state: 'upcoming' },
] as const;

export function SignUpPage() {
  useEffect(() => {
    const previous = document.title;
    document.title = 'Asset Hound | Confidence through intelligence';
    return () => {
      document.title = previous;
    };
  }, []);

  return (
    <div className="signup-page">
      <BrandAtmosphere />
      <a href="#main-content" className="signup-skip">
        Skip to content
      </a>
      <header className="signup-container signup-header">
        <a href="/" className="signup-brand" aria-label="Asset Hound home">
          <img
            src="/brand/asset-hound-icon.png"
            className="signup-brand-mark"
            alt=""
            aria-hidden="true"
            draggable={false}
          />
          <span>asset hound</span>
        </a>
        <a href={accessEmailHref} className="signup-request-link">
          Contact us
        </a>
      </header>

      <main
        id="main-content"
        className="signup-container signup-main"
        tabIndex={-1}
      >
        <div className="signup-copy">
          <p className="signup-audience">UK insolvency &amp; restructuring</p>
          <h1 aria-label="Confidence through intelligence.">
            <span>Confidence</span>
            <span>through</span>
            <span className="signup-accent">intelligence.</span>
          </h1>
          <p className="signup-intro">
            Asset Hound is in private development. We are speaking with a small
            number of practitioners and firms ahead of our public launch.
          </p>
          <a href={requestAccessHref} className="signup-button">
            Find out more <ArrowRight size={18} aria-hidden="true" />
          </a>
        </div>

        <aside className="signup-progress" aria-labelledby="progress-heading">
          <h2 id="progress-heading">The Roadmap</h2>
          <ol>
            {milestones.map((milestone) => (
              <li
                key={milestone.title}
                className={`signup-milestone signup-milestone-${milestone.state}`}
                aria-current={
                  milestone.state === 'current' ? 'step' : undefined
                }
              >
                <span className="signup-milestone-label">
                  {milestone.title}
                </span>
                <span className="signup-milestone-status">
                  {milestone.status}
                </span>
              </li>
            ))}
          </ol>
          <p className="signup-roadmap-note">
            Register your interest ahead of our public launch.
          </p>
        </aside>
      </main>
      <WebsiteFooter />
    </div>
  );
}
